import { Client } from "@/clients/client";

export class AskCenAiUseCase {
  constructor(private client: Client) {}

  public async chat(message: string, sessionId?: string | null, companyId?: number | null): Promise<any> {
    return this.client.askCenAiClient.chat({ message, sessionId, companyId });
  }
}
